import { render, staticRenderFns } from "./HelpingHand.vue?vue&type=template&id=553ef608&scoped=true&"
import script from "./HelpingHand.vue?vue&type=script&lang=js&"
export * from "./HelpingHand.vue?vue&type=script&lang=js&"
import style0 from "./HelpingHand.vue?vue&type=style&index=0&id=553ef608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ef608",
  null
  
)

export default component.exports